import React from 'react';
import Rotate from './Rotate';
import util from 'Utils/commonUtil';

class ScrollWrapper extends React.PureComponent {
    scrollTimer = null;

    constructor(props) {
        super(props);
        this.showAbyss = props.showAbyss;
        this.showLoadingMore = props.showLoadingMore;
        this.listLoaded = props.listLoaded;
    }

    componentDidMount() {
        if (!this.props.notScrollTop) {
            if (document.documentElement) {
                document.documentElement.scrollTop = 0;
            } else {
                document.body.scrollTop = 0;
            }
        }

        window.addEventListener('scroll', this.onScroll);
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.onScroll);
        this.scrollTime && window.clearTimeout(this.scrollTime);
    }

    componentDidUpdate() {
        this.showAbyss = this.props.showAbyss;
        this.listLoaded = this.props.listLoaded;
        this.showLoadingMore = this.props.showLoadingMore;
    }

    onScroll = () => {
        const {getPrevData, getMoreData} = this.props;
        let scrollTop =
            document.documentElement.scrollTop || document.body.scrollTop;
        let clientHeight =
            window.innerHeight ||
            document.documentElement.clientHeight ||
            document.body.clientHeight;
        let scrollHeight =
            document.documentElement.scrollHeight || document.body.scrollHeight;

        window.clearTimeout(window.getMoreDataTimer);
        window.getMoreDataTimer = window.setTimeout(() => {
            if (
                this.listLoaded &&
                scrollTop !== 0 &&
                scrollTop >= (scrollHeight - clientHeight) * 0.9 &&
                !this.showAbyss
            ) {
                if (util.isFunction(getMoreData)) getMoreData();
            }

            if (this.listLoaded && scrollTop === 0) {
                if (util.isFunction(getPrevData)) getPrevData();
            }
        }, 100);
    };

    render() {
        // console.log("this.props.showLoadingMore", this.props.showLoadingMore);
        return (
            <React.Fragment>
                {this.props.children}
                <Rotate
                    showLoadingMore={this.props.showLoadingMore}
                    showAbyss={this.props.showAbyss}
                />
            </React.Fragment>
        );
    }
}

export default ScrollWrapper;
